export default __webpack_public_path__ + "static/media/ewz_icon.3f67aad7.jpg";